<template>
    <div
        class="container"
        style="max-width: 800px">
        <Notifications />
        <div v-show="newsletterIsLoaded">
            <div class="card mt-2 m-md-4 overflow-hidden">
                <NuxtPage />
            </div>
            <div class="p-4 mt-4 d-flex justify-content-center">
                <Impressum />
            </div>
        </div>
        <div v-show="!newsletterIsLoaded">
            <div
                class="d-flex justify-content-center align-items-center"
                style="height: 100vh">
                <font-awesome-icon
                    icon="circle-notch"
                    spin
                    size="8x"
                    class="text-primary" />
            </div>
        </div>
    </div>
</template>
<script>

import mainSubscriptionMixin from "../mixins/mainSubscriptionMixin.js";

export default {
    name: "NewsletterSubscription",
    mixins: [mainSubscriptionMixin],
}
</script>

<style lang="scss" scoped>

</style>
